module.exports = __webpack_public_path__ + "img/1.15d3a3e9.jpg";